<!-- eslint-disable vue/no-v-html -->
<template>
	<div
		class="paragraph"
		:class="[`p-${paddingNum()}`, model.backgroundColor?.cssClass, model.bmetricId]"
	>
		<countdown
			v-if="model.countdownEndDate && model.countdownPositionTop"
			:title="model.countdownTitle"
			:endDate="model.countdownEndDate"
			:expiredText="model.countdownExpiredText"
			:positionTop="model.countdownPositionTop"
		/>
		<div class="paragraph__title rich-text">
			<template v-if="model.header">
				<h2 class="text-center">{{ model.header }}</h2>
				<hr />
			</template>
		</div>
		<div
			v-if="model.richText"
			class="paragraph__content rich-text"
			:class="model.contentText && !isExpandableActive ? 'add-fade' : ''"
			v-html="model.richText"
		></div>
		<template v-if="model.contentText">
			<transition name="extend">
				<div
					v-if="model.richText"
					v-show="isExpandableActive"
					class="rich-text"
					v-html="model.contentText"
				></div>
			</transition>
			<div
				class="paragraph__cut"
				:class="{ 'paragraph__cut--active': isExpandableActive }"
			>
				<p class="paragraph__cut-label">Læs mere</p>
				<div class="paragraph__cut-button">
					<button
						class="btn btn--sm-pad btn--secondary"
						@click="toggleExpandable"
					>
						<smart-svg
							:url="IconSystemChevronDown"
							:width="20"
							:height="20"
						></smart-svg>
					</button>
				</div>
			</div>
		</template>
		<countdown
			v-if="model.countdownEndDate && !model.countdownPositionTop"
			:title="model.countdownTitle"
			:endDate="model.countdownEndDate"
			:expiredText="model.countdownExpiredText"
		/>
		<CtaGroup
			v-if="model.buttons"
			:buttons="model.buttons"
			:ctaMarginTop="model.ctaMarginTop"
			:ctaMarginBottom="model.ctaMarginBottom"
			:ctaAlignment="model.ctaAlignment"
			:promotionalTracking="promotionData"
		/>
	</div>
</template>

<script setup lang="ts">
	import { computed, onMounted, ref } from 'vue';
	import { IParagraphBlock } from '@/types/block';
	import IconSystemChevronDown from '@/assets/svg/icon_system_Chevron_down.svg';
	import {
		dataLayer,
		gtmTrackSelectPromotion,
		gtmTrackViewPromotion,
		handleGtmHeader,
	} from '@/components/utilities/trackingUtility';
	import { CtaGroup } from '@/components/shared/CtaGroup';

	const props = defineProps<{
		model: IParagraphBlock;
		spacing?: [string, string];
	}>();

	const isExpandableActive = ref(false);

	const toggleExpandable = () => {
		isExpandableActive.value = !isExpandableActive.value;
	};

	const paddingNum = () => {
		if (props.model?.padding) {
			return props.model.padding;
		}
		return '0';
	};

	const promotionData = computed(() => {
		if (props.model.richText && props.model.trackAsPromotion) {
			return gtmTrackSelectPromotion(
				'paragraph promotion',
				props.model.contentType,
				handleGtmHeader(props.model.richText, 'missing promotion name')
			);
		}
		return null;
	});

	const handleViewPromotionTracking = () => {
		const { trackAsPromotion, contentType, richText } = props.model;

		if (!trackAsPromotion || !dataLayer || !richText) return;

		gtmTrackViewPromotion('paragraph promotion', contentType, handleGtmHeader(richText, 'missing promotion name'));
	};

	onMounted(() => {
		setTimeout(() => {
			handleViewPromotionTracking();
		}, 1250);
	});
</script>

<style lang="scss">
	@import './ParagraphBlock.module.scss';
</style>
